<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<wa-button [routerLink]="['/plugins']" appearance="plain" variant="neutral">Back to Plugins</wa-button>
		<wa-card appearance="outlined">
			<div class="wa-stack wa-gap-m">
				<div class="wa-stack wa-gap-s">
					<h1 waHeading="xl" waText>FullCalendar</h1>
					<p waBody="m" waText>Full-featured calendar &#40;FullCalendar 6.1.19&#41; &mdash; drag-and-drop scheduling, multiple views, timezone support, and server-driven event management with Angular integration. Supports DayGrid, TimeGrid, List views, recurring events, localization for 50+ locales, and Bootstrap 5 theming.</p>
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25+</wa-tag>
						<wa-tag pill variant="neutral">FullCalendar 6.1.19</wa-tag>
						<wa-tag pill variant="neutral">Angular 21</wa-tag>
						<wa-tag pill variant="neutral">TypeScript 5</wa-tag>
						<wa-tag pill variant="neutral">JPMS Modular</wa-tag>
					</div>
				</div>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-xs">
					<div waCaption="s" waFontWeight="semibold" waText>COORDINATES &amp; MODULE</div>
					<p waBody="s" waText>Maven: com.jwebmp.plugins:fullcalendar</p>
					<p waBody="s" waText>JPMS Module: com.jwebmp.plugins.fullcalendar</p>
					<p waBody="s" waText>Built on: FullCalendar 6.1.19</p>
				</div>
				<wa-details summary="Installation">
					<div class="wa-stack wa-gap-xs">
						@if (!useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Maven</div>
								<markdown [data]="mdContent_581" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
						@if (useGradle) {
							<div class="code-block-wrapper">
								<div class="code-block-label" waCaption="s" waFontWeight="semibold" waText>Gradle &#40;Kotlin DSL&#41;</div>
								<markdown [data]="mdContent_582" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
							</div>
						}
					</div>
				</wa-details>
				<wa-details summary="NPM Dependencies (auto-included)">
					<markdown [data]="mdContent_583" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-stack wa-gap-m">
					<h2 waHeading="l" waText>Components &#40;3&#41;</h2>
					<p waBody="m" waText>Click any component to see its full API &mdash; properties, constructors, methods, events, slots, and examples.</p>
					<div class="wa-grid wa-gap-s" style="--min-column-size:18rem;">
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FullCalendar</h4>
								<p waBody="s" waColorText="quiet" waText>Abstract base FullCalendar component &mdash; renders a full-size drag-and-drop calendar with WebSocket-driven events, resources, and options channels</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">13 props</wa-tag>
									<wa-tag pill variant="neutral">9 methods</wa-tag>
									<wa-tag pill variant="success">1 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fullcalendar/full-calendar']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FullCalendarOptions</h4>
								<p waBody="s" waColorText="quiet" waText>Root calendar options &mdash; toolbar, views, locale, sizing, time slots, date navigation, drag-and-drop, selection, event display, and resource configuration</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">28 props</wa-tag>
									<wa-tag pill variant="neutral">13 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fullcalendar/full-calendar-options']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
						<wa-card appearance="outlined">
							<div class="wa-stack wa-gap-xs">
								<h4 waHeading="s" waText>FullCalendarEvent</h4>
								<p waBody="s" waColorText="quiet" waText>Event object &mdash; represents a single calendar event with title, dates, colors, drag/resize behavior, and resource association</p>
								<div class="wa-cluster wa-gap-xs">
									<wa-tag pill variant="brand">19 props</wa-tag>
									<wa-tag pill variant="neutral">10 methods</wa-tag>
									<wa-tag pill variant="success">2 examples</wa-tag>
								</div>
								<wa-button [routerLink]="['/plugins/fullcalendar/full-calendar-event']" appearance="plain" variant="brand">View Details &rarr;</wa-button>
							</div>
						</wa-card>
					</div>
				</div>
				<wa-details summary="Features (12)">
					<div class="wa-stack wa-gap-xs">
						<p waBody="s" waColorText="quiet" waText>Full calendar views &mdash; Day, Week, Month, List, and custom views</p>
						<p waBody="s" waColorText="quiet" waText>Drag and drop events &mdash; interactive event creation, editing, and rescheduling</p>
						<p waBody="s" waColorText="quiet" waText>Multiple calendar types &mdash; DayGrid, TimeGrid, List</p>
						<p waBody="s" waColorText="quiet" waText>Full IANA timezone support via Moment Timezone</p>
						<p waBody="s" waColorText="quiet" waText>Localization &mdash; multi-language support with 50+ locales</p>
						<p waBody="s" waColorText="quiet" waText>Event sources &mdash; JSON feeds, functions, Google Calendar integration</p>
						<p waBody="s" waColorText="quiet" waText>Recurring events with RRule support</p>
						<p waBody="s" waColorText="quiet" waText>Bootstrap 5 theme integration</p>
						<p waBody="s" waColorText="quiet" waText>Mobile adaptive &mdash; responsive design with touch support</p>
						<p waBody="s" waColorText="quiet" waText>Type-safe Java API &mdash; CRTP fluent API for calendar configuration</p>
						<p waBody="s" waColorText="quiet" waText>Server-driven config &mdash; configure calendar entirely from Java backend</p>
						<p waBody="s" waColorText="quiet" waText>Automatic Jackson serialization for Angular binding</p>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Examples (1)">
					<div class="wa-stack wa-gap-m">
						<div class="wa-stack wa-gap-xs">
							<h4 waHeading="s" waText>Calendar with Events</h4>
							<p waBody="s" waColorText="quiet" waText>Create a month-view calendar with drag-and-drop events.</p>
							<markdown [data]="mdContent_584" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="Quick Start">
					<markdown [data]="mdContent_585" class="aside-snippet-code wa-body-s" clipboard lineNumbers></markdown>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="SPI Extension Point Details (1)">
					<div class="wa-stack wa-gap-s">
						<div class="wa-stack wa-gap-xs">
							<div class="wa-cluster wa-gap-xs">
								<wa-tag pill variant="success">IPageConfigurator</wa-tag>
								<wa-tag pill variant="neutral">provides</wa-tag>
							</div>
							<p waBody="s" waColorText="quiet" waText>FullCalendarPageConfigurator auto-registers FullCalendar CSS/JS and Angular integration</p>
						</div>
					</div>
				</wa-details>
				<wa-details open summary="SPI Extension Points">
					<div class="wa-stack wa-gap-xs">
						<div class="wa-cluster wa-gap-xs">
							<wa-tag pill variant="success">provides IPageConfigurator</wa-tag>
						</div>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<wa-details open summary="Prerequisites">
					<div class="wa-cluster wa-gap-xs">
						<wa-tag pill variant="neutral">Java 25 LTS</wa-tag>
						<wa-tag pill variant="neutral">Maven 3.9+</wa-tag>
						<wa-tag pill variant="neutral">Node.js 18+</wa-tag>
						<wa-tag pill variant="neutral">Angular 21+</wa-tag>
					</div>
				</wa-details>
				<wa-divider></wa-divider>
				<div class="wa-cluster wa-gap-s">
					<wa-tag pill variant="neutral">Upstream: https://fullcalendar.io/</wa-tag>
					<wa-tag pill variant="neutral">Docs: https://fullcalendar.io/docs</wa-tag>
					<wa-tag pill variant="neutral">Source: https://github.com/JWebMP/FullCalendar</wa-tag>
				</div>
			</div>
		</wa-card>
	</div>
</div>